import { createContext } from "react";

export const CreditorsContext = createContext([]);
